/**
 * Provide a library of functions that act like appserver API
 *   requests but don't actually contact appserver.
 * This is intended for "demo mode" which will be used by Apple
 *   App Store reviewers to verify the app's functionality.
 * These fake API calls return sample data after a short tmeout.
 */

import * as appserver from "lib/appserver/request";

import sampleData from "state/sampleData";

/**
 * Time in ms to wait before returning data.
 */
const SIMULATED_REQUEST_DELAY = 500;

/**
 * Simulate a data request by returning a promise that will
 *   resolve with the given data after a delay.
 */
function simulateRequest(responseData) {
  return new Promise(resolve => {
    window.setTimeout(() => {
      resolve({
        data: {
          status: "success",
          data: responseData
        }
      });
    }, SIMULATED_REQUEST_DELAY);
  });
}

/**
 * Simulate appserver's GetMyApps() API.
 */
export function simulateAvailableProductsRequest(mobileNumber, deviceToken) {
  return simulateRequest(sampleData.available_products);
}

/**
 * Simulate appserver's ServiceAppServerDataRequest() API.
 */
export function simulateDataRequest(mobileNumber, deviceToken, application, { request_cmd }) {
  return simulateRequest(sampleData[application][request_cmd]);
}

/**
 * Simulate the given appserver API.
 * @param {Function} appserverAPI availableProductsRequest || dataRequest
 * @param {Object} args same as args to appserver APIs
 * @returns {Promise}
 */
export function getAPISimulator(appserverAPI) {
  switch (appserverAPI) {
    case appserver.availableProductsRequest:
      return simulateAvailableProductsRequest;
    case appserver.dataRequest:
      return simulateDataRequest;
    default:
      throw new Error("Cannot simulate appserver API: %s", appserverAPI.name);
  }
}



// WEBPACK FOOTER //
// ./src/state/demoMode.js